<template>
  <div>
    <layout :top="true" :hasBottom="false">
      <div slot="head">
        <TopTabbar/>
      </div>
      <div slot="content" class="con">
        <video
          src="https://img3a.gemtec.ltd/shj-video.mp4"
          autoplay="autoplay"
          controls="controls"
          :style="'width:100%;height:'+imgheight+'rem'"
          loop="loop"
        >您的浏览器不支持播放该视频！</video>
      </div>
    </layout>
  </div>
</template>
<script>
import layout from "@/components/layout.vue";
import TopTabbar from "@/components/TopTabbar.vue";
import { Swipe, SwipeItem } from "vant";
import Vue from "vue";
Vue.use(Swipe).use(SwipeItem);
export default {
  components: {
    layout,
    TopTabbar
  },
  data() {
    return {
      list: []
    };
  },
  computed: {
    imgheight() {
      return (this.$store.state.screenHeight - 44) / 102.4;
    }
  },
  methods: {
    Jump() {
      this.$router.push("/videoDetail");
    }
  },
  created() {}
};
</script>
<style lang="scss" scoped>
.con {
  display: flex;
  background: #000;
  video {
    height: 100%;
    width: 100%;
  }
}
</style>
